import { ReactElement } from 'react';
import classNames from 'classnames';

import Loader from '../loader/loader';

import styles from './modal.module.scss';

interface Props {
    target?: any;
    children: ReactElement | ReactElement[];
    onConfirm: (target?: any) => void;
    discardText?: string;
    onDiscard?: () => void;
    confirmText?: string;
    confirmLoading?: boolean;
    confirmDisabled?: boolean;
}

const Modal = (props: Props) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.fade} onClick={props.onDiscard} />
            <div className={styles.modal}>
                {props.children}
                <div className={styles.buttons}>
                    {props.onDiscard && (
                        <button
                            className={styles.discardButton}
                            onClick={props.onDiscard}
                        >
                            {props.discardText ?? 'Descartar'}
                        </button>
                    )}
                    <button
                        className={classNames({
                            [styles.confirmButton]: true,
                            [styles.loading]: props.confirmLoading,
                            [styles.disabled]: props.confirmDisabled,
                        })}
                        disabled={props.confirmDisabled}
                        onClick={() => props.onConfirm(props.target)}
                    >
                        {props.confirmLoading ? (
                            <>
                                <Loader size={14} /> Cargando...
                            </>
                        ) : (
                            props.confirmText ?? 'Confirmar'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
